var map = {
	"./arrow_down.svg": "4b1a",
	"./arrow_forward.svg": "aa66",
	"./calendar.svg": "b8bd",
	"./close-icon.svg": "3e79",
	"./info.svg": "76ed",
	"./language-world.svg": "2944",
	"./logout.svg": "69e3",
	"./password-changed.svg": "72b6",
	"./pending-tasks.svg": "e0e3",
	"./plus-icon.svg": "0a7c",
	"./protocol-approved.svg": "4dbc",
	"./protocol-rejected.svg": "95d2",
	"./protocol-waiting-for-approval.svg": "0139",
	"./relapse-reported.svg": "96cc",
	"./settings.svg": "9174",
	"./toggle.svg": "39ae"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";